import { Box, Chip, Tooltip } from "@mui/material";
import { CheckCircle, Error, Sync } from "@mui/icons-material"
import { useMemo } from "react";

export type FileStatusType = "queued" | "uploading" | "success" | "error"

export interface FileStatusDisplayProps {
    status: FileStatusType;
    progress?: number;
    error?: string;
}

export const FileStatusDisplay = ({ status, progress, error }: FileStatusDisplayProps) => {
    const tooltip = useMemo(() => getTooltip(status, error), [status, error]);

    return (
        <Tooltip title={tooltip} placement="top">
            <div>
                <FileStatusValue status={status} progress={progress} />
            </div>
        </Tooltip>
    );
}

function FileStatusValue({ status, progress }: { status: FileStatusType, progress?: number }) {
    switch (status) {
        case "error":
            return <Box color="red"><Error /></Box>;
        case "queued":
            return <Box color="gray"><Sync /></Box>;
        case "uploading":
            const label = `${Math.floor(progress)} %`;
            return <Chip size="small" label={label} color="primary" variant="outlined" />;
        case "success":
            return <Box color="green"><CheckCircle /></Box>
        default:
            return null;
    }
}

function getTooltip(status: FileStatusType, error: string) {
    switch (status) {
        case "error":
            return "An unexpected error occured while uploading the file";
        case "queued":
            return "The file is queued to be uploaded";
        case "uploading":
            return "The file is being uploaded. Please wait for this task to complete.";
        case "success":
            return "The file has been successfully uploaded";
        default:
            return null;
    }
}
